import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@pella/sash-framework';

const BackButton = ({ title, buttonText = 'Main Menu', as = 'li', className }) => {
	const onBackToMenuClick = (e) => {
		const menu = document.getElementById('js-mobileMenu');
		const parentList = e.currentTarget.parentNode.parentNode;
		const prevParent = parentList.parentNode.parentNode;
		prevParent.classList.remove('!overflow-hidden');
		parentList.classList.remove('visible', 'overflow-y-auto', 'overflow-x-hidden', 'right-0');
		parentList.classList.add('invisible', '-right-80', 'overflow-hidden');

		if (prevParent.parentNode === menu) {
			menu.classList.remove('overflow-hidden');
		}
	};

	const ComponentTag = as;

	return (
		<ComponentTag className={className || ''}>
			<button
				onClick={onBackToMenuClick}
				className='flex w-full items-center border-b border-b-neutral-100 bg-neutral-50 px-2 py-1 leading-none'
				aria-label={title}
			>
				<Icon
					name='keyboard_arrow_left'
					className='mr-1'
				/>
				<span className='text-sm font-semibold uppercase tracking-wider'>{buttonText}</span>
			</button>

			<span className='block bg-white p-4 text-lg font-semibold uppercase !leading-snug'>{title}</span>
		</ComponentTag>
	);
};

BackButton.propTypes = {
	title: PropTypes.string.isRequired,
	buttonText: PropTypes.string,
	as: PropTypes.string,
	className: PropTypes.string,
};

export default BackButton;
